export default "__VITE_ASSET__DJsEOiQE__"